/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrimaryContactDto
 */
export interface PrimaryContactDto {
    /**
     * 
     * @type {string}
     * @memberof PrimaryContactDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PrimaryContactDto
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PrimaryContactDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PrimaryContactDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof PrimaryContactDto
     */
    role?: string;
    /**
     * 
     * @type {string}
     * @memberof PrimaryContactDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PrimaryContactDto
     */
    department?: string;
}

/**
 * Check if a given object implements the PrimaryContactDto interface.
 */
export function instanceOfPrimaryContactDto(value: object): value is PrimaryContactDto {
    return true;
}

export function PrimaryContactDtoFromJSON(json: any): PrimaryContactDto {
    return PrimaryContactDtoFromJSONTyped(json, false);
}

export function PrimaryContactDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrimaryContactDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'role': json['role'] == null ? undefined : json['role'],
        'title': json['title'] == null ? undefined : json['title'],
        'department': json['department'] == null ? undefined : json['department'],
    };
}

export function PrimaryContactDtoToJSON(json: any): PrimaryContactDto {
    return PrimaryContactDtoToJSONTyped(json, false);
}

export function PrimaryContactDtoToJSONTyped(value?: PrimaryContactDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'email': value['email'],
        'phone': value['phone'],
        'role': value['role'],
        'title': value['title'],
        'department': value['department'],
    };
}

